<template>
  <nav
    class="py-10 text-center sidebar"
    :class="{ 'axo-sidebar': role === 'axo', 'is-open': open }"
  >
    <div class="sidebar__link-wrapper" v-if="mainPage">
      <router-link :to="'/' + role + '-dashboard'" class="sidebar__link">
        <HomeIcon class="w-6 h-6" />
        <p>{{ $t("Sidebar.main") }}</p>
      </router-link>
    </div>

    <div
      class="sidebar__link-wrapper sidebar__link--back"
      v-else-if="!mainPage"
    >
      <button @click="router.go(-1)" class="sidebar__link">
        <ChevronLeftIcon class="w-6 h-6" />
      </button>
    </div>

    <!-- Sidebar faqat mainPage true bo'lsa chiqadi -->
    <component v-if="mainPage" :is="role + '-sidebar'" />
  </nav>
</template>

<script>
import { groupIdMixin } from "@/mixins/get-group-id.mixin";
import adminSidebar from "./sidebars/adminSidebar.vue";
import auditSidebar from "./sidebars/auditSidebar.vue";
import academySidebar from "./sidebars/academySidebar.vue";
import { onBeforeMount, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import financeSidebar from "./sidebars/financeSidebar.vue";
import instructorSidebar from "./sidebars/instructorSidebar.vue";
import hunterSidebar from "./sidebars/hunterSidebar.vue";
import axoSidebar from "./sidebars/axoSidebar.vue";
import tutorSidebar from "./sidebars/tutorSidebar.vue";
import branchacademySidebar from "./sidebars/branchacademySidebar.vue";
import marketingSidebar from "./sidebars/marketingSidebar.vue";
import kuratorSidebar from "./sidebars/kuratorSidebar.vue";
import metodistSidebar from "./sidebars/metodistSidebar.vue";
import hrSidebar from "./sidebars/hrSidebar.vue";
import { decryptText } from "@/utils/cryptFunc";
import { HomeIcon, ChevronLeftIcon } from "@heroicons/vue/24/outline";

export default {
  mixins: [groupIdMixin],
  components: {
    adminSidebar,
    auditSidebar,
    financeSidebar,
    academySidebar,
    instructorSidebar,
    axoSidebar,
    hunterSidebar,
    tutorSidebar,
    branchacademySidebar,
    marketingSidebar,
    kuratorSidebar,
    metodistSidebar,
    hrSidebar,
    HomeIcon,
    ChevronLeftIcon,
  },
  props: { open: Boolean },
  emits: ["navigate"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const role = ref(decryptText(localStorage.getItem("role")));
    const mainPage = ref(true);

    const route = useRoute();

    const router = useRouter();

    const checkRoute = (val) => {
      mainPage.value = val?.meta?.layout === "main";
    };

    onBeforeMount(() => {
      checkRoute(route);
    });

    watch(route, (val) => {
      checkRoute(val);
      role.value = decryptText(localStorage.getItem("role"));
      emit("navigate"); // close the mobile drawer after a link is tapped
    });

    return { role, mainPage, router, t };
  },
};
</script>

<style>
.sidebar {
  transition: all 0.3s ease-in-out;
}
</style>
